
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4E6492","fill-rule":"evenodd","d":"M19.657 0H.345A.345.345 0 000 .345v15.173c0 .19.155.345.345.345h19.312c.19 0 .343-.155.343-.345V.345A.344.344 0 0019.657 0zM.69 15.173h2.757v-3.104H.691v3.104zm0-3.794h2.757V8.276H.691v3.103zm0-3.792h2.757V4.482H.691v3.105zm0-3.793h2.757V.69H.691v3.103zM12.6 8.222l-3.794 2.415a.35.35 0 01-.352.011.347.347 0 01-.178-.303V5.518c0-.126.069-.243.178-.303a.347.347 0 01.352.012L12.6 7.64a.344.344 0 010 .58zm3.952 6.95h2.76V12.07h-2.76v3.104zm0-3.793h2.76V8.276h-2.76v3.103zm0-3.792h2.76V4.482h-2.76v3.105zm0-3.793h2.76V.69h-2.76v3.103z"}})])
          )
        }
      }
    